import "./style.less";
import { PasswordReqEx } from "./model";

import LoginForm from "./form-login";
import inputFields from "./input-fields/module";
// import FormValidationErrors from "./form-validation-errors";
//import FormValidationService from "./form-validation-errors/service";

const modul = angular
    .module("forms", [inputFields])

    .constant("PasswordReqEx", PasswordReqEx)
    //.service("FormValidationService", FormValidationService)

    .directive("loginForm", LoginForm);
// .directive("formValidationErrors", FormValidationErrors);

export default modul.name;
